import React from 'react';
import './PlayerSelection.css'
 
//Receive all selected players data.
const PlayerSelection = (props) => {
    const playerCart = props.selectPlayer;
    const totalBudget = playerCart.reduce((totalBudget, player) => totalBudget + Number(player.salary), 0);
     

    return (
        //Display total player whose are selected and display that's players name's and salary whose are selected and also display the total budget.
        <div className="display-selected-player">
            <h2>Total Player Selected: {playerCart.length}</h2>
             {
                playerCart.map(playerName =><div className="cart-selected-player">

               <h3>Name: {playerName.name} </h3>
               <h3>Salary: {playerName.salary}</h3> <br/> 

                </div>)
             } 
           
            <h4 className="text-success border-top">TotalBudget: {totalBudget}</h4>
        </div>
    );
};

export default PlayerSelection;